import { useForm, DefaultValues } from 'react-hook-form';
import type { TenantCreate, TenantUpdate } from '../types/tenant.types';
import { useCallback } from 'react';

export interface UseTenantFormProps {
  defaultValues?: DefaultValues<TenantCreate | TenantUpdate>;
  onSubmit: (data: TenantCreate | TenantUpdate) => void;
}

export const useTenantForm = ({ defaultValues, onSubmit }: UseTenantFormProps) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setError,
    setValue,
  } = useForm<TenantCreate | TenantUpdate>({
    defaultValues: defaultValues || {
      name: undefined,
      addressLine1: undefined,
      addressLine2: undefined,
      city: undefined,
      state: undefined,
      zipCode: undefined,
      countryId: undefined,
      region: undefined,
      primaryEmail: undefined,
      secondaryEmail: undefined,
      primaryPhone: undefined,
      secondaryPhone: undefined,
      defaultLanguage: undefined,
      defaultCurrency: undefined,
      parentTenantId: undefined,
      brandingColors: undefined,
      billingPlanId: undefined,
      supportPlanId: undefined,
      contractStartDate: undefined,
      contractEndDate: undefined,
      notes: undefined,
    },
  });

  const resetForm = useCallback(() => {
    reset();
  }, [reset]);

  const submitHandler = useCallback(
    (data: TenantCreate | TenantUpdate) => {
      onSubmit(data);
    },
    [onSubmit]
  );

  const formSubmitHandler = useCallback(() => {
    return handleSubmit(submitHandler);
  }, [handleSubmit, submitHandler]);

  return {
    control,
    errors,
    resetForm,
    formSubmitHandler,
    reset,
    setError,
    setValue,
  };
};
